module.exports = __webpack_public_path__ + "img/Superintendente.abc34bc0.png";